// Una línea que se recalcula por un cambio guardado, y la fila que se resuelve mientras se la mira (card Fnvibexi,
// /ux 04/11). Atómica subió el presupuesto de la línea como le pedía el mail y la pantalla le siguió diciendo que
// estaba mal: ahora la fila dice «Recalculando…», la bandeja se refresca sola hasta que termina y, si el aviso se
// resolvió, queda en su lugar como «Resuelta» en vez de desaparecer.
//
// Lógica pura para que la usen igual la pantalla de Alertas del cliente y «Ahora» (el refresco es
// `useRecalculationRefresh.js`).

// El mismo tope que el backend (`BusinessUnit.RECALCULATION_MAX_MINUTES`): pasado eso, la marca ya no es
// «se está recalculando» y el ícono que gira mentiría.
export const RECALCULATION_MAX_MS = 10 * 60 * 1000;
export const RECALCULATION_REFRESH_MS = 15 * 1000;

function sinceOf(item) {
    const since = item && item.recalculating_since ? new Date(item.recalculating_since).getTime() : NaN;
    return isNaN(since) ? null : since;
}

/** ¿La línea de esta fila se está recalculando ahora? */
export function isRecalculating(item, now = Date.now()) {
    const since = sinceOf(item);
    return since !== null && now - since < RECALCULATION_MAX_MS;
}

/** Hasta cuándo vale la pena refrescar (el tope más lejano de las filas que se recalculan), o `null`. */
export function recalculationDeadline(items, now = Date.now()) {
    const deadlines = (items || []).filter((item) => isRecalculating(item, now))
        .map((item) => sinceOf(item) + RECALCULATION_MAX_MS);
    return deadlines.length ? Math.max(...deadlines) : null;
}

/**
 * Las resueltas después de una lectura, como `Map<id, {item, phrase, index, clientId}>`.
 *
 * Se suman las filas que estaban en pantalla (`previousActive`) y ahora vuelven en `recovered`: el backend dice
 * que se RECUPERARON, así que una fila que se fue por otro motivo (la silenciaron, cerró el período) no se pinta
 * como resuelta. Una que vuelve a estar vigente deja de estar resuelta. `index` es su lugar de antes.
 */
export function nextResolved(resolved, previousActive, recovered, currentActive) {
    const next = new Map(resolved || []);
    const recoveredById = new Map((recovered || []).filter((row) => row && row.id).map((row) => [row.id, row]));
    const currentIds = new Set((currentActive || []).map((item) => item && item.id).filter(Boolean));
    (previousActive || []).forEach((item, index) => {
        if (!item || !item.id || currentIds.has(item.id) || next.has(item.id)) return;
        const recovery = recoveredById.get(item.id);
        if (recovery) {
            next.set(item.id, {item, phrase: recovery.recovered_phrase, index, clientId: recovery.client_id});
        }
    });
    currentIds.forEach((id) => next.delete(id));
    return next;
}

/** Las filas a dibujar: las vigentes y, en su lugar de antes, las resueltas. `[{item, resolved: null|{phrase}}]`. */
export function withResolvedRows(active, resolvedEntries) {
    const rows = (active || []).map((item) => ({item, resolved: null}));
    [...(resolvedEntries || [])].sort((a, b) => a.index - b.index).forEach((entry) => {
        rows.splice(Math.min(entry.index, rows.length), 0, {item: entry.item, resolved: {phrase: entry.phrase}});
    });
    return rows;
}
